module.exports = __webpack_public_path__ + "static/BeastSprite-8a053a6beaa31fda0f42d270b284b544.png";